import Vue from 'vue';
import App from '@/App';

import '@/components/index';

import '@/plugins/vuelidate';

import '@/assets/tailwind.css'; // ✅ Must be before any other custom CSS
import store from '@/store/index';
import router from '@/router/index';
import i18n from '@/i18n';

import './assets/tailwind.css';

Vue.config.productionTip = false;
if (process.env.VUE_APP_SHOW_ON_ENV === 'prod') {
(function(f, b, e, v, n, t, s) {
	if (f.fbq) return;
	n = f.fbq = function() {
	  n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
	};
	if (!f._fbq) f._fbq = n;
	n.push = n;
	n.loaded = !0;
	n.version = '2.0';
	n.queue = [];
	t = b.createElement(e);
	t.async = !0;
	t.src = 'https://connect.facebook.net/en_US/fbevents.js';
	s = b.getElementsByTagName(e)[0];
	s.parentNode.insertBefore(t, s);
  })(window, document, 'script');
  
  fbq('init', '1686250881998324'); // Replace with your Pixel ID
  fbq('track', 'PageView');
}
  
new Vue({
	store,
	router,
	i18n,
	render: h => h(App),
}).$mount('#app')
